var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSino = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "20px",
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "B6292DDC-BAF5-4EA7-B845-E597E374DBB3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-",
    transform: "translate(-1273.000000, -22.000000)",
    fill: "#4B4B4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1282.79212,39.6130659 L1282.7925,39.6286972 C1282.7925,40.9383325 1281.76613,42 1280.50003,42 C1279.23394,42 1278.20757,40.9383325 1278.20757,39.6286972 L1278.20757,39.6286972 L1278.20794,39.6130659 L1282.79212,39.6130659 L1282.79212,39.6130659 Z M1280.49999,22 C1281.06922,22 1281.53065,22.4773433 1281.5307,23.0661088 L1281.5307,23.0661088 L1281.5307,24.2705482 C1283.94001,24.7660482 1285.7561,26.9647969 1285.7561,29.6025724 L1285.7561,29.6025724 L1285.7561,33.5138875 L1287.81933,36.6489483 C1288.03662,36.9791655 1288.05964,37.4066104 1287.87902,37.7597739 C1287.69843,38.1128503 1287.34392,38.3337354 1286.95771,38.3337354 L1286.95771,38.3337354 L1274.04227,38.3337354 C1273.65606,38.3337354 1273.30154,38.1128939 1273.12096,37.7597739 C1272.94038,37.406654 1272.96336,36.979209 1273.18069,36.6489918 L1273.18069,36.6489918 L1275.24392,33.513931 L1275.24392,33.513931 L1275.24392,29.602616 C1275.24392,26.9648839 1277.06001,24.7661353 1279.46932,24.2705918 L1279.46932,24.2705918 L1279.46932,23.0661088 C1279.46932,22.4773433 1279.93076,22 1280.49999,22 Z",
    id: "Combined-Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSino, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sino.1a6df89c.svg";
export { ForwardRef as ReactComponent };